import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["src"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import React from 'react';
import styled from 'styled-components';
import { fillParent } from 'styles/mixins';
import { useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
var Iframe = styled.iframe.withConfig({
  displayName: "PDFViewer__Iframe",
  componentId: "sc-s65m1-0"
})(["", " width:100%;height:100%;"], fillParent);
function PDFViewer(_ref) {
  var src = _ref.src,
    props = _objectWithoutProperties(_ref, _excluded);
  var location = useLocation();
  var hashParams = new URLSearchParams(location.hash.replace(/^#/, ''));

  // Rename the position to 'page' for the PDF viewer
  if (hashParams.has('position')) {
    hashParams.set('page', hashParams.get('position'));
    hashParams.delete('position');
  }
  var hash = hashParams.toString();

  // Indicate that the response should wrap the redirect with a hosted PDF Player
  src += "?wrap".concat(hash ? "#".concat(hash) : '');
  return /*#__PURE__*/_jsx(Iframe, _objectSpread({
    src: src
  }, props));
}
export default PDFViewer;